import { useMemo } from "react";

export type TooltipTheme = "default" | "success" | "warning" | "danger";

const useTooltipTheme = (theme: TooltipTheme = "default") => {
  const themes = {
    default: {
      text: "text-white",
      bg: "bg-gray-400",
    },
    success: {
      text: "text-white",
      bg: "bg-teal-600",
    },
    warning: {
      text: "text-black",
      bg: "bg-yellow-500",
    },
    danger: {
      text: "text-white",
      bg: "bg-red-600",
    },
  };

  const selectedTheme = useMemo(() => {
    return themes[theme];
  }, [theme, themes]);

  return selectedTheme;
};

export default useTooltipTheme;
